import { render, staticRenderFns } from "./QuestText.vue?vue&type=template&id=4e76dfed&scoped=true&"
import script from "./QuestText.vue?vue&type=script&lang=js&"
export * from "./QuestText.vue?vue&type=script&lang=js&"
import style0 from "./QuestText.vue?vue&type=style&index=0&id=4e76dfed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e76dfed",
  null
  
)

export default component.exports